import React from 'react';
import { Helmet } from 'react-helmet-async';

import { config } from 'src/config';
import { isBrowser } from 'src/shared/helpers/environment';
import { useNonce } from 'src/shared/hooks';

import { snippet } from './snippet';

const Segment = () => {
  const nonce = useNonce();

  if (!config.SEGMENT_API_KEY || (isBrowser() && window?.analytics)) {
    return null;
  }

  return (
    <Helmet>
      <script nonce={nonce}>{snippet(config.SEGMENT_API_KEY)}</script>
    </Helmet>
  );
};

export { Segment };
